import { Schema } from "nutso";
import { EmlMetadata } from "../models/EmlMetadata";

export const emlMetadataSchema: Schema<EmlMetadata, any, any> = {
  type: "object",
  properties: {
    messageId: {
      type: "string",
    },
    envelopeFrom: {
      type: "string",
    },
    envelopeRecipients: {
      type: "array",
      items: {
        type: "string",
      },
      minItems: 1,
    },
  },
};
